module.exports = __webpack_public_path__ + "img/egg-blue.7cc2e502.svg";